import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../sharedModules/utils/axios.utils';
import { collectionCandidatesQueryKey } from './useCollectionClients';

interface UpdateBackupEmailArgs {
  id: number;
  backup_email: string | null;
  location: string;
}

const updateBackupEmail = async ({ id, backup_email }: UpdateBackupEmailArgs) =>
  axios.patch(`/collections/clients/${id}/backup_email`, { client: { backup_email } });

export const useUpdateCollectionClientBackupEmail = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: updateBackupEmail,
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: [`/collections/clients/${variables.id}`, undefined] });
      void queryClient.invalidateQueries({ queryKey: collectionCandidatesQueryKey(variables.location) });
    },
  });

  return {
    updateBackupEmail: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
};
